<template>
  <div>自用组件component测试</div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>